"use client";
import { useEffect, useState } from "react";
import { Icon } from "./icons";
export function RemindersView() {
  const [visible, setVisible] = useState<
    { id: string; title: string; remind_at: string; derived?: boolean }[]
  >([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    fetch("/api/reminders")
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) setError(data.error ?? "Не удалось загрузить даты");
        return response.ok ? data : { reminders: [] };
      })
      .then((data) => setVisible(data.reminders))
      .finally(() => setLoading(false));
  }, []);
  return (
    <section className="module-view" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:21:5"}>
      <div className="module-heading" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:22:7"}>
        <div data-amazi-id={"crm/src/features/crm/reminders-view.tsx:23:9"}>
          <div className="breadcrumb" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:24:11"}>
            Рабочее пространство <span data-amazi-id={"crm/src/features/crm/reminders-view.tsx:25:34"}>/</span> Напоминания
          </div>
          <h1 data-amazi-id={"crm/src/features/crm/reminders-view.tsx:27:11"}>Напоминания</h1>
          <p data-amazi-id={"crm/src/features/crm/reminders-view.tsx:28:11"}>Примерки, готовность и просроченные заказы</p>
        </div>
        <button className="primary-button" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:30:9"}>
          <Icon name="plus" size={16} data-amazi-jsx-id={"crm/src/features/crm/reminders-view.tsx:31:11"} /> Создать напоминание
        </button>
      </div>
      <div className="panel reminder-panel" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:34:7"}>
        <div className="reminder-intro" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:35:9"}>
          <div className="reminder-icon" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:36:11"}>
            <Icon name="bell" size={20} data-amazi-jsx-id={"crm/src/features/crm/reminders-view.tsx:37:13"} />
          </div>
          <div data-amazi-id={"crm/src/features/crm/reminders-view.tsx:39:11"}>
            <h2 data-amazi-id={"crm/src/features/crm/reminders-view.tsx:40:13"}>На сегодня</h2>
            <p data-amazi-id={"crm/src/features/crm/reminders-view.tsx:41:13"}>Не пропустите важные действия</p>
          </div>
          <strong data-amazi-id={"crm/src/features/crm/reminders-view.tsx:43:11"}>{visible.length}</strong>
        </div>
        {loading && <div className="empty-message" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:45:21"}>Загружаем напоминания…</div>}
        {error && (
          <div className="form-error" role="alert" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:47:11"}>
            {error}
          </div>
        )}
        {!loading && visible.length === 0 && (
          <div className="empty-message" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:52:11"}>Активных напоминаний нет.</div>
        )}
        {visible.map((item) => (
          <div className="reminder-row" key={item.title} data-amazi-id={"crm/src/features/crm/reminders-view.tsx:55:11"}>
            <div className="reminder-dot" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:56:13"} />
            <div data-amazi-id={"crm/src/features/crm/reminders-view.tsx:57:13"}>
              <strong data-amazi-id={"crm/src/features/crm/reminders-view.tsx:58:15"}>{item.title}</strong>
              <span data-amazi-id={"crm/src/features/crm/reminders-view.tsx:59:15"}>Контрольная дата заказа</span>
            </div>
            <time data-amazi-id={"crm/src/features/crm/reminders-view.tsx:61:13"}>{new Date(item.remind_at).toLocaleString("ru-RU")}</time>
            {item.derived ? (
              <span className="priority yellow" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:63:15"}>Дата заказа</span>
            ) : (
              <button
                className="ack-button"
                onClick={() =>
                  fetch(`/api/reminders/${item.id}`, { method: "POST" }).then(() =>
                    setVisible((current) => current.filter((reminder) => reminder.id !== item.id)),
                  )
                }
               data-amazi-id={"crm/src/features/crm/reminders-view.tsx:65:15"}>
                Готово
              </button>
            )}
          </div>
        ))}
        {visible.length === 0 && (
          <div className="empty-message" data-amazi-id={"crm/src/features/crm/reminders-view.tsx:79:11"}>Все напоминания обработаны. Отличная работа!</div>
        )}
      </div>
    </section>
  );
}
